import { Component } from '@angular/core';

@Component({
    selector: 'app-recurring-payment-menu',
    templateUrl: './recurring-payment-menu.component.html',
})
export class RecurringPaymentMenuComponent {}
